import { render } from "./TextComponent.vue?vue&type=template&id=55df48be&scoped=true&ts=true"
import script from "./TextComponent.vue?vue&type=script&lang=ts"
export * from "./TextComponent.vue?vue&type=script&lang=ts"

import "./TextComponent.vue?vue&type=style&index=0&id=55df48be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55df48be"]])

export default __exports__